import { FC, SVGProps } from 'react';

export const CheckboxNotSelected: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2.65" y="2.65" width="14.7" height="14.7" rx="2.90556" stroke="#878B92" strokeWidth="1.3" />
  </svg>
);
